// Settings · Notifications in the parent app (0038). English counterpart of pushApp.nl.ts.
export const appPushEn = {
    title: 'Notifications',
    subtitle: 'Little nudges on your phone. You choose what you get.',
    settingsBody: 'Reminders, rides and messages on your phone',
    device: {
        title: 'On this device',
        on: 'Notifications are on for this device.',
        off: 'Notifications are still off for this device.',
        turnOn: 'Turn on notifications',
        turnOff: 'Turn off on this device',
        test: 'Send a test notification',
        testSent: 'Test sent. It will arrive in a moment.',
        testNone: 'No phone is signed up yet.',
        testOff: 'Sending is turned off on this server.',
        turnedOn: 'Notifications are on',
        turnedOff: 'Notifications are off on this device',
        denied: 'Your browser blocks notifications from AMUMIN. Allow them in your browser or phone settings and come back.',
        unsupported: 'This browser cannot receive notifications.',
        nativeApp: 'Notifications do not arrive in the AMUMIN iPhone app yet. Want them now? Open AMUMIN in Safari and add it to your home screen.',
        unavailable: 'Notifications are not set up yet. Please try again later.',
        needsInstall: 'On iPhone and iPad, notifications only arrive when AMUMIN is on your home screen. Add it there first (see below), then open AMUMIN from your home screen.',
        notAllowedChild: 'A parent turns notifications on for you.',
        inUse: 'This browser is already signed up for someone else in your family.',
        nothingChosen: 'You have not picked anything, so no notifications will come.',
        loginNote: 'Notifications come as long as you are signed in on this device. Sign out and they stop.',
    },
    install: {
        title: 'Put AMUMIN on your home screen',
        body: 'Then AMUMIN opens with one tap, just like an app. It is free and there is nothing to download.',
        installed: 'AMUMIN is on your home screen.',
        platform: 'Which device?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Computer',
        iosNote: 'Notifications work from iOS 16.4, when AMUMIN is on your home screen.',
        androidButton: 'Install AMUMIN',
        desktopButton: 'Install AMUMIN',
    },
    kinds: {
        title: 'What would you like to get?',
        autosave: 'What you tick is saved right away.',
        reminders: 'My reminders',
        remindersHint: 'At the same moment the tablet calls.',
        remindersChildren: "Also my children's reminders",
        rides: 'Rides',
        ridesHint: '"Who takes Yakub tomorrow at 08:15?" and who takes over a ride.',
        approvals: 'What waits for my yes',
        approvalsHint: 'Bundled in one notification, at most once every half hour.',
        messages: 'New messages',
        departure: 'Time to leave',
        departureHint: 'When the event has a travel time.',
        summary: 'Daily summary',
        summaryHint: 'A short summary of the calendar every day.',
        summaryAt: 'At',
    },
    quiet: {
        title: 'Quiet hours',
        toggle: 'No notifications during quiet hours',
        from: 'From',
        to: 'Until',
        note: 'Reminders you made for yourself still come through.',
    },
    discreet: {
        title: 'Discreet on the lock screen',
        body: 'Notifications travel encrypted through the service of Apple, Google, Mozilla or Microsoft. They cannot read them. But anyone can glance at your lock screen. That is why by default it only shows "AMUMIN" and what kind of notification it is.',
        all: 'Everything discreet',
        allHint: 'On by default. You only see "AMUMIN" with "A reminder", "Something about a ride", "Something is waiting for your yes" or "A new message". Turn this off to see details: the title, names, the time, the place and the text of a message.',
        sensitive: 'Faith, care and school discreet',
        sensitiveHint: 'Even with details on: when we can tell from the icon or from words such as "speech therapy", "eye doctor", "iftar", "Eid", "report card" or "teacher" that an event, reminder or message is about care, faith or school, the notification stays discreet. No word list is complete: if in doubt, keep everything discreet.',
    },
    children: {
        title: 'Children',
        body: 'A child with their own login can get notifications too, if you agree. This is off by default.',
        allow: 'Notifications for {name}',
        noLogin: '{name} has no login of their own.',
        none: 'There are no children in your family yet.',
        toastOn: '{name} can now get notifications',
        toastOff: '{name} no longer gets notifications',
    },
    devices: {
        title: 'Your phones and browsers',
        none: 'No phone or browser signed up yet.',
        since: 'Signed up on {date}',
        lastUsed: 'Last notification {date}',
        error: 'The last notification did not arrive.',
        remove: 'Remove',
        removeLabel: 'Remove {name}',
        removed: 'Removed',
        thisOne: 'This one',
    },
    save: 'Save',
    saved: 'Saved',
    offTitle: 'Notifications are off',
    offBody: 'Notifications are off for your family. A parent can turn them on under Modules.',
};
//# sourceMappingURL=pushApp.en.js.map